export default __webpack_public_path__ + "static/media/define-who-will-use-system.800bd1e7.svg";